import { Helpers } from '../../helpers';
import { IArea } from '../../interfaces/iarea';
import { AreaFactor } from '../area-factor';
import { AreaTargetFormationFactor } from '../area-target-formation-factor';
import { AreaTeam } from '../area-team';
import { AreaType } from '../area-type';
import { Asset } from '../asset';
import { AssetTeam } from '../asset-team';
import { AutoMappingCombiningTargetFormation } from '../auto-mapping-combining-target-formation';
import { AutoRelationship } from '../auto-relationship';
import { BudgetAdjustment } from '../budget-adjustment';
import { CompletionsAreaTeam } from '../completions-area-team';
import { ConstraintCalendarRestrictionDetail } from '../constraint-calendar-restriction-detail';
import { ConstraintDrillFracInterferenceDetail } from '../constraint-drill-frac-interference-detail';
import { ConstraintFacilityConstrainedScheduleDetail } from '../constraint-facility-constrained-schedule-detail';
import { ConstraintFacilityExpansionDetail } from '../constraint-facility-expansion-detail';
import { ConstraintFacilityInitialBuildDetail } from '../constraint-facility-initial-build-detail';
import { ConstraintFacilityTruckDetail } from '../constraint-facility-truck-detail';
import { ConstraintLeaseObligation } from '../constraint-lease-obligation';
import { ConstraintManualObligation } from '../constraint-manual-obligation';
import { ConstraintMaxFracFleetPerAreaDetail } from '../constraint-max-frac-fleet-per-area-detail';
import { ConstraintMinMaxRigsPerAreaDetail } from '../constraint-min-max-rigs-per-area-detail';
import { ConstraintPopSlidesAllowableDay } from '../constraint-pop-slides-allowable-day';
import { ConstraintPrematureWellShutdownDetail } from '../constraint-premature-well-shutdown-detail';
import { ConstraintProvenUndrilledObligation } from '../constraint-proven-undrilled-obligation';
import { ConstraintSpudLimitDetail } from '../constraint-spud-limit-detail';
import { ConstraintWaterSupply } from '../constraint-water-supply';
import { DrillingAreaTeam } from '../drilling-area-team';
import { FieldDevelopmentTeam } from '../field-development-team';
import { FormationTop } from '../formation-top';
import { LandArea } from '../land-area';
import { LandingPoint } from '../landing-point';
import { Lease } from '../lease';
import { Pad } from '../pad';
import { Project } from '../project';
import { SaltWaterDisposalFacility } from '../salt-water-disposal-facility';
import { ScenarioWell } from '../scenario-well';
import { TankBattery } from '../tank-battery';
import { TypeCurve } from '../type-curve';
import { WaterDisposalSystem } from '../water-disposal-system';
import { WaterNetwork } from '../water-network';
import { WaterWell } from '../water-well';
import { Well } from '../well';

export class AreaBase {
  AreaId: number;
  Description: string | null;
  Alias: string | null;
  SortOrder: number | null;
  AreaTeamId: number | null;
  FieldDevelopmentTeamId: number | null;
  CompletionsAreaTeamId: number | null;
  DrillingAreaTeamId: number | null;
  BaseSrkbtvd: number | null;
  TOPSAshaleKbtvd: number | null;
  TopLsskbtvd: number | null;
  TOPWfcpa1kbtvd: number | null;
  AssetTeamId: number | null;
  WaterNetworkId: number | null;
  LandAreaId: number | null;
  CostMatrixInput: boolean;
  AreaTypeId: number | null;
  Spatial: object | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  SpatialOutline: object | null;

  AreaFactors_Area?: Array<AreaFactor> | null;
  AreaTargetFormationFactors_Area?: Array<AreaTargetFormationFactor> | null;
  AutoMappingCombiningTargetFormations_Area?: Array<AutoMappingCombiningTargetFormation> | null;
  AutoRelationships_Area?: Array<AutoRelationship> | null;
  BudgetAdjustments_Area?: Array<BudgetAdjustment> | null;
  ConstraintCalendarRestrictionDetails_Area?: Array<ConstraintCalendarRestrictionDetail> | null;
  ConstraintDrillFracInterferenceDetails_Area?: Array<ConstraintDrillFracInterferenceDetail> | null;
  ConstraintFacilityConstrainedScheduleDetails_Area?: Array<ConstraintFacilityConstrainedScheduleDetail> | null;
  ConstraintFacilityExpansionDetails_Area?: Array<ConstraintFacilityExpansionDetail> | null;
  ConstraintFacilityInitialBuildDetails_Area?: Array<ConstraintFacilityInitialBuildDetail> | null;
  ConstraintFacilityTruckDetails_Area?: Array<ConstraintFacilityTruckDetail> | null;
  ConstraintLeaseObligations_Area?: Array<ConstraintLeaseObligation> | null;
  ConstraintManualObligations_Area?: Array<ConstraintManualObligation> | null;
  ConstraintMaxFracFleetPerAreaDetails_Area?: Array<ConstraintMaxFracFleetPerAreaDetail> | null;
  ConstraintMinMaxRigsPerAreaDetails_Area?: Array<ConstraintMinMaxRigsPerAreaDetail> | null;
  ConstraintPopSlidesAllowableDays_Area?: Array<ConstraintPopSlidesAllowableDay> | null;
  ConstraintPrematureWellShutdownDetails_Area?: Array<ConstraintPrematureWellShutdownDetail> | null;
  ConstraintProvenUndrilledObligations_Area?: Array<ConstraintProvenUndrilledObligation> | null;
  ConstraintSpudLimitDetails_Area?: Array<ConstraintSpudLimitDetail> | null;
  FormationTops_Area?: Array<FormationTop> | null;
  LandingPoints_Area?: Array<LandingPoint> | null;
  Leases_Area?: Array<Lease> | null;
  SaltWaterDisposalFacilities_Area?: Array<SaltWaterDisposalFacility> | null;
  WaterWells_Area?: Array<WaterWell> | null;
  Assets_CompletionsArea?: Array<Asset> | null;
  Assets_DevelopmentArea?: Array<Asset> | null;
  Assets_DrillingArea?: Array<Asset> | null;
  Assets_HorizontalOpsArea?: Array<Asset> | null;
  Assets_PIGArea?: Array<Asset> | null;
  Assets_TankBatteryArea?: Array<Asset> | null;
  Assets_TypeCurveArea?: Array<Asset> | null;
  Assets_WaterDisposalSystemArea?: Array<Asset> | null;
  ConstraintWaterSupplies_WaterNetworkArea?: Array<ConstraintWaterSupply> | null;
  Pads_TankBatteryArea?: Array<Pad> | null;
  Projects_TeamDevelopmentArea?: Array<Project> | null;
  SaltWaterDisposalFacilities_TankBatteryArea?: Array<SaltWaterDisposalFacility> | null;
  SaltWaterDisposalFacilities_WaterDispoalSystemArea?: Array<SaltWaterDisposalFacility> | null;
  ScenarioWells_WaterDisposalSystemArea?: Array<ScenarioWell> | null;
  TankBatteries_TankBatteryArea?: Array<TankBattery> | null;
  TankBatteries_WaterDispoalSystemArea?: Array<TankBattery> | null;
  TypeCurves_TypeCurveArea?: Array<TypeCurve> | null;
  WaterDisposalSystems_WaterDisposalSystemArea?: Array<WaterDisposalSystem> | null;
  Wells_LeaseArea?: Array<Well> | null;
  AreaTeam?: AreaTeam;
  AreaType?: AreaType;
  AssetTeam?: AssetTeam;
  CompletionsAreaTeam?: CompletionsAreaTeam;
  DrillingAreaTeam?: DrillingAreaTeam;
  FieldDevelopmentTeam?: FieldDevelopmentTeam;
  LandArea?: LandArea;
  WaterNetwork?: WaterNetwork;

  constructor(item?: IArea) {
    if (item) {

      this.AreaId = item.AreaId;
      this.Description = item.Description;
      this.Alias = item.Alias;
      this.SortOrder = item.SortOrder;
      this.AreaTeamId = item.AreaTeamId;
      this.FieldDevelopmentTeamId = item.FieldDevelopmentTeamId;
      this.CompletionsAreaTeamId = item.CompletionsAreaTeamId;
      this.DrillingAreaTeamId = item.DrillingAreaTeamId;
      this.BaseSrkbtvd = item.BaseSrkbtvd;
      this.TOPSAshaleKbtvd = item.TOPSAshaleKbtvd;
      this.TopLsskbtvd = item.TopLsskbtvd;
      this.TOPWfcpa1kbtvd = item.TOPWfcpa1kbtvd;
      this.AssetTeamId = item.AssetTeamId;
      this.WaterNetworkId = item.WaterNetworkId;
      this.LandAreaId = item.LandAreaId;
      this.CostMatrixInput = item.CostMatrixInput;
      this.AreaTypeId = item.AreaTypeId;
      this.Spatial = item.Spatial;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.SpatialOutline = item.SpatialOutline;

      this.AreaFactors_Area = Helpers.createClassArray(AreaFactor, item.AreaFactors_Area);
      this.AreaTargetFormationFactors_Area = Helpers.createClassArray(AreaTargetFormationFactor, item.AreaTargetFormationFactors_Area);
      this.AutoMappingCombiningTargetFormations_Area = Helpers.createClassArray(AutoMappingCombiningTargetFormation, item.AutoMappingCombiningTargetFormations_Area);
      this.AutoRelationships_Area = Helpers.createClassArray(AutoRelationship, item.AutoRelationships_Area);
      this.BudgetAdjustments_Area = Helpers.createClassArray(BudgetAdjustment, item.BudgetAdjustments_Area);
      this.ConstraintCalendarRestrictionDetails_Area = Helpers.createClassArray(ConstraintCalendarRestrictionDetail, item.ConstraintCalendarRestrictionDetails_Area);
      this.ConstraintDrillFracInterferenceDetails_Area = Helpers.createClassArray(ConstraintDrillFracInterferenceDetail, item.ConstraintDrillFracInterferenceDetails_Area);
      this.ConstraintFacilityConstrainedScheduleDetails_Area = Helpers.createClassArray(ConstraintFacilityConstrainedScheduleDetail, item.ConstraintFacilityConstrainedScheduleDetails_Area);
      this.ConstraintFacilityExpansionDetails_Area = Helpers.createClassArray(ConstraintFacilityExpansionDetail, item.ConstraintFacilityExpansionDetails_Area);
      this.ConstraintFacilityInitialBuildDetails_Area = Helpers.createClassArray(ConstraintFacilityInitialBuildDetail, item.ConstraintFacilityInitialBuildDetails_Area);
      this.ConstraintFacilityTruckDetails_Area = Helpers.createClassArray(ConstraintFacilityTruckDetail, item.ConstraintFacilityTruckDetails_Area);
      this.ConstraintLeaseObligations_Area = Helpers.createClassArray(ConstraintLeaseObligation, item.ConstraintLeaseObligations_Area);
      this.ConstraintManualObligations_Area = Helpers.createClassArray(ConstraintManualObligation, item.ConstraintManualObligations_Area);
      this.ConstraintMaxFracFleetPerAreaDetails_Area = Helpers.createClassArray(ConstraintMaxFracFleetPerAreaDetail, item.ConstraintMaxFracFleetPerAreaDetails_Area);
      this.ConstraintMinMaxRigsPerAreaDetails_Area = Helpers.createClassArray(ConstraintMinMaxRigsPerAreaDetail, item.ConstraintMinMaxRigsPerAreaDetails_Area);
      this.ConstraintPopSlidesAllowableDays_Area = Helpers.createClassArray(ConstraintPopSlidesAllowableDay, item.ConstraintPopSlidesAllowableDays_Area);
      this.ConstraintPrematureWellShutdownDetails_Area = Helpers.createClassArray(ConstraintPrematureWellShutdownDetail, item.ConstraintPrematureWellShutdownDetails_Area);
      this.ConstraintProvenUndrilledObligations_Area = Helpers.createClassArray(ConstraintProvenUndrilledObligation, item.ConstraintProvenUndrilledObligations_Area);
      this.ConstraintSpudLimitDetails_Area = Helpers.createClassArray(ConstraintSpudLimitDetail, item.ConstraintSpudLimitDetails_Area);
      this.FormationTops_Area = Helpers.createClassArray(FormationTop, item.FormationTops_Area);
      this.LandingPoints_Area = Helpers.createClassArray(LandingPoint, item.LandingPoints_Area);
      this.Leases_Area = Helpers.createClassArray(Lease, item.Leases_Area);
      this.SaltWaterDisposalFacilities_Area = Helpers.createClassArray(SaltWaterDisposalFacility, item.SaltWaterDisposalFacilities_Area);
      this.WaterWells_Area = Helpers.createClassArray(WaterWell, item.WaterWells_Area);
      this.Assets_CompletionsArea = Helpers.createClassArray(Asset, item.Assets_CompletionsArea);
      this.Assets_DevelopmentArea = Helpers.createClassArray(Asset, item.Assets_DevelopmentArea);
      this.Assets_DrillingArea = Helpers.createClassArray(Asset, item.Assets_DrillingArea);
      this.Assets_HorizontalOpsArea = Helpers.createClassArray(Asset, item.Assets_HorizontalOpsArea);
      this.Assets_PIGArea = Helpers.createClassArray(Asset, item.Assets_PIGArea);
      this.Assets_TankBatteryArea = Helpers.createClassArray(Asset, item.Assets_TankBatteryArea);
      this.Assets_TypeCurveArea = Helpers.createClassArray(Asset, item.Assets_TypeCurveArea);
      this.Assets_WaterDisposalSystemArea = Helpers.createClassArray(Asset, item.Assets_WaterDisposalSystemArea);
      this.ConstraintWaterSupplies_WaterNetworkArea = Helpers.createClassArray(ConstraintWaterSupply, item.ConstraintWaterSupplies_WaterNetworkArea);
      this.Pads_TankBatteryArea = Helpers.createClassArray(Pad, item.Pads_TankBatteryArea);
      this.Projects_TeamDevelopmentArea = Helpers.createClassArray(Project, item.Projects_TeamDevelopmentArea);
      this.SaltWaterDisposalFacilities_TankBatteryArea = Helpers.createClassArray(SaltWaterDisposalFacility, item.SaltWaterDisposalFacilities_TankBatteryArea);
      this.SaltWaterDisposalFacilities_WaterDispoalSystemArea = Helpers.createClassArray(SaltWaterDisposalFacility, item.SaltWaterDisposalFacilities_WaterDispoalSystemArea);
      this.ScenarioWells_WaterDisposalSystemArea = Helpers.createClassArray(ScenarioWell, item.ScenarioWells_WaterDisposalSystemArea);
      this.TankBatteries_TankBatteryArea = Helpers.createClassArray(TankBattery, item.TankBatteries_TankBatteryArea);
      this.TankBatteries_WaterDispoalSystemArea = Helpers.createClassArray(TankBattery, item.TankBatteries_WaterDispoalSystemArea);
      this.TypeCurves_TypeCurveArea = Helpers.createClassArray(TypeCurve, item.TypeCurves_TypeCurveArea);
      this.WaterDisposalSystems_WaterDisposalSystemArea = Helpers.createClassArray(WaterDisposalSystem, item.WaterDisposalSystems_WaterDisposalSystemArea);
      this.Wells_LeaseArea = Helpers.createClassArray(Well, item.Wells_LeaseArea);
      this.AreaTeam = new AreaTeam(item.AreaTeam);
      this.AreaType = new AreaType(item.AreaType);
      this.AssetTeam = new AssetTeam(item.AssetTeam);
      this.CompletionsAreaTeam = new CompletionsAreaTeam(item.CompletionsAreaTeam);
      this.DrillingAreaTeam = new DrillingAreaTeam(item.DrillingAreaTeam);
      this.FieldDevelopmentTeam = new FieldDevelopmentTeam(item.FieldDevelopmentTeam);
      this.LandArea = new LandArea(item.LandArea);
      this.WaterNetwork = new WaterNetwork(item.WaterNetwork);
    }
  }
}